import './_autocomplete-search-empty-state.scss';
import component from './autocomplete-search-empty-state';

export default component;
